module.exports = __webpack_public_path__ + "static/img/Bachelor_010714.af35488.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010714.jpg
// module id = 230
// module chunks = 0